module.exports = __webpack_public_path__ + "img/terroir-grid-4.c590c70f.jpg";